import React, { forwardRef } from "react";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { StyledTooltip, StyledDiv, StyledText } from "./tooltip.styles";
import { TooltipProps, ToolTipRef } from "./tooltip.types";

const tooltipProps = {
    light: {
        bgColor: "colorWhite",
        titleColor: "colorTextSecondary",
        supportTextColor: "colorTextDescription",
    },
    dark: {
        bgColor: "colorBgSpotlight",
        titleColor: "colorBgBase",
        supportTextColor: "colorBgBase",
    },
};

const themeMap = {
    light: "theme-light",
    dark: "theme-dark",
};

const constructTooltipTitle = (title, supportText, color, token) => {
    if (!title) return null;

    return (
        <StyledDiv>
            <StyledText color={token[tooltipProps[color]["titleColor"]]} strong>
                {title}
            </StyledText>
            {supportText ? (
                <StyledText
                    color={token[tooltipProps[color]["supportTextColor"]]}
                >
                    {supportText}
                </StyledText>
            ) : null}
        </StyledDiv>
    );
};

export const Tooltip = forwardRef(
    (
        {
            children,
            title,
            supportText = "",
            theme = "dark",
            className = "",
            ...rest
        }: TooltipProps,
        ref: ToolTipRef
    ) => {
        const token = useEnigmaToken();
        return (
            <StyledTooltip
                ref={ref}
                {...rest}
                title={constructTooltipTitle(title, supportText, theme, token)}
                color={token[tooltipProps[theme]["bgColor"]]}
                className={`${className} ${themeMap[theme]}`}
                destroyTooltipOnHide
            >
                {children}
            </StyledTooltip>
        );
    }
);

Tooltip.displayName = "Tooltip";
